import { render, staticRenderFns } from "./FutureLayerLogoMenu.vue?vue&type=template&id=f078c87e&scoped=true&"
import script from "./FutureLayerLogoMenu.vue?vue&type=script&lang=ts&"
export * from "./FutureLayerLogoMenu.vue?vue&type=script&lang=ts&"
import style0 from "./FutureLayerLogoMenu.vue?vue&type=style&index=0&id=f078c87e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f078c87e",
  null
  
)

export default component.exports